import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

import { getThumbIcon } from './apis'
// import styles from './style.module.scss'

function DomainIcon({ domain, size, alt, defaultUrl, defaultElem, classNames: clsName }) {
  const [imgUrl, setImgUrl] = useState(null)

  useEffect(() => {
    const loadImg = () => {
      if (domain != null) {
        getThumbIcon(domain, size)
          .then((url) => {
            setImgUrl(url)
          })
          .catch((e) => {
            console.log(' --- loadImg error ', e)
            setImgUrl(null)
          })
      } else {
        setImgUrl(null)
      }
    }

    loadImg()
  }, [domain, size])

  if (defaultElem != null) {
    if (imgUrl != null) {
      return (
        <span className={classNames(clsName)}>
          <img src={imgUrl} alt={alt} />
        </span>
      )
    }
    return <span className={classNames(clsName)}>{defaultElem}</span>
  }

  const url = imgUrl != null ? imgUrl : defaultUrl

  return (
    <span className={classNames(clsName)}>
      <img src={url} alt={alt} />
    </span>
  )
}

export default DomainIcon
